export default __webpack_public_path__ + "static/media/preloader.a05125b8.GIF";